import "./modal.style.scss";

import React from "react";

const Modal = ({ modal = <div />, dismiss = () => {} }) => {
	return (
		<div className="modal-container flex flex--center absolute fill">
			<div onClick={dismiss} className="absolute fill" />
			{modal}
		</div>
	);
};

export default Modal;
